const analyticsEvent = (category, action, label, value) => {
    const source = JSON.parse(localStorage.getItem('sourceShare')) ? 'Share' : 'Download';
    const version = localStorage.getItem('extensionVersion');
    typeof gtag === 'function' && gtag('event', action, {
        'event_category': category,
        'event_label': label,
        'value': value,
        'source': source,
        'version': version
    });
};

const setCustomDimensions = () => {
    typeof gtag === 'function' && gtag('config', 'G-C3GBDBE5PN');
};

const sendGAEventToExtension = (category, action, label, value) => {
    let event = new CustomEvent('gaEventToExtension', {
        detail: {
            category: category,
            action: action,
            label: label || null,
            value: value || null
        }
    });
    document.dispatchEvent(event);
};

setCustomDimensions();


export {analyticsEvent, sendGAEventToExtension};
